module.exports = __webpack_public_path__ + "img/RAL3018_USA.ddeac852.png";